import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-drop-down",
  templateUrl: "./drop-down.component.html",
  styleUrls: ["./drop-down.component.less"]
})
export class DropDownComponent implements OnInit {
  constructor() {
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// E:/project/muyiwang/svn/project-code/trad-portal/src/app/drop-down/drop-down.component.ts